export const optionToLabel = (option: string) => {
  if (!option) {
    return '';
  }

  return option
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const arrayToOptions = (values: Array<number | string>, suffix = '') =>
  Array.from(new Set(values)).map((item) => ({
    label: `${typeof item === 'string' ? optionToLabel(item) : String(item)}${suffix}`,
    value: item,
  })) ?? [];
